package com.macrofocus.eflux.ui

import com.macrofocus.common.selection.MutableSelection
import com.macrofocus.eflux.components.blurBackground
import com.macrofocus.eflux.network.schema.Schema
import emotion.react.css
import mui.material.Box
import mui.material.PaletteMode
import mui.material.styles.Palette
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import mui.system.sx
import org.mkui.react.useSelection
import react.FC
import react.Props
import react.dom.html.ReactHTML.img
import web.cssom.*

external interface SchemaProps : Props {
    var schemas: Array<Schema>
    var selection: MutableSelection<Schema>
}

val Schema = FC<SchemaProps> { props ->
    val theme = useTheme<Theme>()

    val (getSchema, setSchema) = useSelection(props.selection)

    if(getSchema.size > 0) {
        val schema = getSchema[0]
        val customBackground: (SxProps<Theme>) -> Unit = { it ->
            it.blurBackground(theme)
        }

        Box {
            sx {
                position = Position.absolute
                top = 200.px
                bottom = 50.px
                left = 50.px
                right = 50.px

                pointerEvents = None.none
            }
            img {
                src = "schema/${schema.schemaId}.svg"
                alt = "${schema.schemaId}"

                css {
//                            width = 100.pct
                    height = Auto.auto
                    margin = Auto.auto
                    maxWidth = 100.pct
                    maxHeight = 100.pct
                    objectFit = ObjectFit.contain
                    display = Display.block

                    backgroundColor = if (theme.palette.unsafeCast<Palette>().mode == PaletteMode.light) rgb(255, 255, 255, 0.90) else rgb(0, 0, 0, 0.9)
                    boxShadow = BoxShadow(0.px, 3.px, 5.px, -1.px, rgb(0, 0, 0, 0.3))
                    backdropFilter = blur(4.px)

                    pointerEvents = PointerEvents.all
                }

                onClick = {
                    props.selection.clearSelection()
                }
            }
        }
    }

}